/**
 * share模块接口列表
 */
import request from '@/router/axios'

export const getShareHardware = (encryption_key) => {
  return  request({
    method: 'post',
    url: `/api/share/hardware`,
    data: {encryption_key:encryption_key}
  })
}
export const getSameConfiguration = (encryption_key) => {
  return  request({
    method: 'post',
    url: `/v1/Rankhardware/get_same_configuration`,
    data: {encryption_key:encryption_key}
  })
}

export const getFavoritesCount = (encryption_key) => {
  return  request({
    method: 'post',
    url: `/api/computercount/favorites`,
    data: {encryption_key: encryption_key}
  })
}

export const shareFileInfo = (encryption_id) => {
  return request({
    method: 'get',
    url: `/api/share/fileinfo`,
    params: {
      encryption_id: encryption_id
    }
  })
}
export const getCloudpath = (encryption_id) => {
  return request({
    method: 'get',
    url: `/api/share/cloudpath`,
    params: {
      encryption_id: encryption_id
    }
  })
}
export const getBanType = () => {
  return request({
    method: 'post',
    url: `/v1/usersharefilesbantype/index`,
    data: {}
  })
}
export const submitBan = (data) => {
  return request({
    method: 'post',
    url: `/v1/usersharefilesban/submit`,
    data,
  })
}





// WEBPACK FOOTER //
// ./src/api/hardware.js